import { IAuthenticationState } from "./authenticationState";

export default {};
